module.exports = __webpack_public_path__ + "images/help_v2/avatars/zeyan-0a1c0d21ebc870eb0455189c786f2ead.png";